// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import { menuItems, partnerItems, viewerItems } from 'menu-items';
import { useSelector } from 'react-redux';

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
    const user = useSelector((state) => state.auth.user);
    let nav = '';

    switch (user.perfil_id) {
        case 1:
            nav = menuItems;
            break;
        case 2:
            nav = partnerItems;
            break;
        case 3:
            nav = menuItems;
            break;
        case 4:
            nav = viewerItems;
            break;
    }

    const navItems = nav.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
